enum LogicalOperator {
  And = 'And',
  Or = 'Or',
}

export default LogicalOperator;
